// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Ідеї» (Ideas, ключ `idea`, група `creative`). */
export const ideasManifest: IModuleManifest = {
  key: 'idea',
  group: 'creative',
  slug: 'ideas',
  prefix: 'IDE',
  name: { en: 'Ideas', uk: 'Ідеї' },
  entities: [
    { key: 'idea', slug: 'idea', name: { en: 'Ideas', uk: 'Ідеї' }, main: true },
    { key: 'ichal', slug: 'ichal', name: { en: 'Innovation challenges', uk: 'Виклики для ідей' }, main: false },
  ],
  loadState: () => import('./state/ideasSlice').then((m) => m.ideasSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
  loadViews: () => import('./views').then((m) => m.views),
};
